import axios from "../instance";

export default {
  getAll: () => {
    return axios.api.get("/vendor").then((response) => response.data);
  },
  getOne: (id) => {
    return axios.api.get(`/vendor/${id}`).then((response) => response.data);
  },
  search: (body) => {
    return axios.api
      .post("/vendor/search", body)
      .then((response) => response.data);
  },
  create: (body) => {
    return axios.api.post("/vendor", body).then((response) => response.data);
  },
  update: (id, body) => {
    return axios.api
      .put(`/vendor/${id}`, body)
      .then((response) => response.data);
  },
  delete: (id) => {
    return axios.api.delete(`/vendor/${id}`).then((response) => response.data);
  },
};
